<template>
    <div class="toolbar-container">
        <div class="toolbar">
            <b-row no-gutters style="gap: 20px;">
                <div class="col-sm">
                    <div :class="zoomClass" title="Current Zoom Level">
                        <div class="white-outline highlight">
                            <div> {{ zoomFloor }} </div>
                        </div>
                    </div>
                </div>
                <div title="Mileage Slider" class="col-sm highlight toolbar-icon" @click="$emit('toggleSlider')">
                    <fa :icon="['fas', 'sliders-h']" size="lg" />
                </div>
                <div title="Upload CSV Here!" class="col-sm highlight toolbar-icon"
                    @click="$bvModal.show('POIUploadModal')">
                    <fa :icon="['fas', 'upload']" size="lg" />
                </div>
                <!-- <div class="col-sm highlight toolbar-icon" @click="$emit('returnHome')" title="Return to home screen">
                    <fa :icon="['fas', 'home']" size="lg" />
                </div> -->
            </b-row>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
    name: 'MMP_Analytics_ToolBar',
    props: ['map', 'zoomLevel'],
    computed: {
        zoomFloor() {
            return Math.floor(this.zoomLevel); // Only updates when the whole number changes
        },
        zoomClass() {
            return {
                box: true,
                'box-emphasis': this.emphasizeZoom
            };
        }
    },
    components: {
        VueSlider
    },
    data() {
        return {
            lastZoomLevel: null,
            emphasizeZoom: false
        };
    },
    watch: {
        zoomFloor(newZoom, oldZoom) {
            if (newZoom !== oldZoom) {
                this.emphasizeZoom = true;

                // Remove emphasis after a short delay
                setTimeout(() => {
                    this.emphasizeZoom = false;
                }, 500);
            }
        }
    }
};
</script>

<style scoped>
.toolbar-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.toolbar-icon:hover {
    opacity: 0.8;
}

.toolbar-container {
    width: 130px;
    height: 30px;
    background: #063c6d;
    /* background: rgb(21.45, 140.4, 87.1); */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    right: 6px;
    border-radius: 5px;
}

.toolbar {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 30px;
    flex-direction: column;
}

.mileage-slider b {
    color: yellow;
}

.box {
    height: 28px;
    width: 36px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: font-size 0.66s ease, color 0.5s ease, height 0.5s ease, width 0.5s ease, border-radius 0.66s ease;
    font-size: 16px;
    color: white;
}

.box-emphasis {
    font-size: 20px !important;
    color: yellow !important;
}

.white-outline {
    height: 90%;
    width: 90%;
    border: 3px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

.highlight:hover {
    font-size: 16px;
}
</style>
